import { ParsedUrlQuery, stringify } from 'querystring';

import { SearchParameters, SearchResultType } from '@ms/yammer-data/dist/state/types';

import { searchPathPublisherQuestions } from './questions';

export const searchPathThreads = '/search/threads';
export const searchPathGroups = '/search/groups';
export const searchPathUsers = '/search/users';
export const searchPathFiles = '/search/files';
export const searchPathInbox = '/search/inbox';
export const searchPathTopics = '/search/topics';
export const searchPathCampaigns = '/search/campaigns';
export const searchPathQuestions = '/search/questions';

export const searchQueryTextKey = 'search';
export const searchQueryGroupScopeKey = 'groupScope';
export const searchQueryStartDateKey = 'start';
export const searchQueryEndDateKey = 'end';
export const searchQueryTypeKey = 'type';
export const searchQueryTypeInboxValue = 'inbox';
export const searchQueryNetworkIdKey = 'networkId';

const paths: Record<SearchResultType, string> = {
  [SearchResultType.Thread]: searchPathThreads,
  [SearchResultType.Group]: searchPathGroups,
  [SearchResultType.User]: searchPathUsers,
  [SearchResultType.File]: searchPathFiles,
  [SearchResultType.Inbox]: searchPathInbox,
  [SearchResultType.Topic]: searchPathTopics,
  [SearchResultType.NetworkQuestion]: searchPathQuestions,
  [SearchResultType.PublisherNetworkQuestion]: searchPathPublisherQuestions,
  [SearchResultType.Campaign]: searchPathCampaigns,
};
type SearchPageWithParameters = (searchParameters: SearchParameters) => string;

export const searchPageWithParameters: SearchPageWithParameters = (searchParameters) => {
  const queryParameters = makeSearchQueryStringParameters(searchParameters);

  return `${paths[searchParameters.resultType]}?${stringify(queryParameters as unknown as ParsedUrlQuery)}`;
};

export interface SearchQueryParameters {
  readonly [searchQueryTextKey]: string;
  readonly [searchQueryGroupScopeKey]?: string;
  readonly [searchQueryTypeKey]?: string;
  readonly [searchQueryStartDateKey]?: number;
  readonly [searchQueryEndDateKey]?: number;
  readonly [searchQueryNetworkIdKey]?: string;
}

type MakeQueryObjectWithSearchParameters = (searchParameters: SearchParameters) => SearchQueryParameters;

export const makeSearchQueryStringParameters: MakeQueryObjectWithSearchParameters = ({
  resultType,
  searchText,
  groupScope,
  startTimestamp,
  endTimestamp,
  networkIds,
}) => {
  const searchTextParameter = { [searchQueryTextKey]: searchText };
  const groupScopeParameter = groupScope ? { [searchQueryGroupScopeKey]: groupScope } : {};
  const typeParameter =
    resultType === SearchResultType.Inbox ? { [searchQueryTypeKey]: searchQueryTypeInboxValue } : {};
  const startTimestampParameter = startTimestamp ? { [searchQueryStartDateKey]: startTimestamp } : {};
  const endTimestampParameter = endTimestamp ? { [searchQueryEndDateKey]: endTimestamp } : {};
  const networkIdParameter = networkIds && networkIds.length === 1 ? { [searchQueryNetworkIdKey]: networkIds[0] } : {};

  return {
    ...searchTextParameter,
    ...groupScopeParameter,
    ...typeParameter,
    ...startTimestampParameter,
    ...endTimestampParameter,
    ...networkIdParameter,
  };
};
